import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Container,
  Dropdown,
  Image,
  Menu
} from 'semantic-ui-react';
import { useHistory } from "react-router-dom";
import { getCurrentUser } from '../actions/userActions';

const FixedMenu = (props) => {
  useEffect(() => {
    if (localStorage.getItem("token")) {
      props.getCurrentUser();
    }
  }, []);

  const history = useHistory();

  const handleLoginLogout = () => {
    if (props.user.loggedIn) {
      localStorage.removeItem('token');
      history.go("/login");
    } else {
      history.push("/login");
    }
  }

  return (
    <Menu fixed='top' inverted>
      <Container>
        <Menu.Item header onClick={() => history.push("/events")}>
          Funeral Live Admin
        </Menu.Item>
        {
          props.user.loggedIn && props.user.user && props.user.user.superadminRole && 
          <Menu.Item
            name='Funeral Homes'
            onClick={() => history.push("/funeralhomes")}
          />
        }
        {
          props.user.loggedIn && props.user.user && props.user.user.superadminRole && 
          <Menu.Item
            name='Onboard'
            onClick={() => history.push("/onboard")}
          />
        }
        <Menu.Menu position='right'>
          <Menu.Item
            name={props.user.loggedIn ? 'logout' : 'login'}
            onClick={handleLoginLogout}
          />
        </Menu.Menu>
      </Container>
    </Menu>
  );
};

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = {
  getCurrentUser
};

export default connect(mapStateToProps, mapDispatchToProps)(FixedMenu);
